import { render, staticRenderFns } from "./ShipmentArchive.vue?vue&type=template&id=45c79a90&"
import script from "./ShipmentArchive.vue?vue&type=script&lang=js&"
export * from "./ShipmentArchive.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports